/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const NotificationPollTimeSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('NOTIFICATION_POLL_TIME')],
    ['value', /* #__PURE__ */ parsers.maybeNull(parsers.duration)],
]);
export class NotificationPollTimeSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return NotificationPollTimeSettingParser.decode(input).map(res => new NotificationPollTimeSetting(res));
    }
    static unsafeDecode(input) {
        return NotificationPollTimeSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NotificationPollTimeSettingParser.encode(data);
    }
    static schema() {
        return NotificationPollTimeSettingParser.schema();
    }
}
